import { avatarColor, initials } from '../lib/utils'

export default function PersonCard({ person, onClick }) {
  const color = avatarColor(person.first_name + person.last_name)
  const meta = [
    person.city,
    person.nickname ? `"${person.nickname}"` : '',
    person.email,
  ].filter(Boolean)

  return (
    <div className="person-card" onClick={() => onClick(person.id)}>
      <div className="avatar" style={{ background: color }}>
        {initials(person.first_name, person.last_name)}
      </div>
      <div className="person-info">
        <div className="person-name">{person.first_name} {person.last_name}</div>
        {meta.length > 0 && (
          <div className="person-meta">
            {meta.map((m, i) => <span key={i}>{m}</span>)}
          </div>
        )}
      </div>
      <div className="person-right">
        {person.result_count > 0 && (
          <span className="result-count">{person.result_count} Profile</span>
        )}
        <span className={`badge badge-${person.status}`}>{person.status}</span>
      </div>
    </div>
  )
}
